import { render, staticRenderFns } from "./RealMCQView.vue?vue&type=template&id=8945dbb2&"
import script from "./RealMCQView.vue?vue&type=script&lang=js&"
export * from "./RealMCQView.vue?vue&type=script&lang=js&"
import style0 from "./RealMCQView.vue?vue&type=style&index=0&id=8945dbb2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports